export enum PythonType {
  Str = "str",
  Bool = "bool",
}
